import { render, staticRenderFns } from "./TaxRiskEvaluate.vue?vue&type=template&id=6b3e6a5c&scoped=true"
import script from "./TaxRiskEvaluate.vue?vue&type=script&lang=js"
export * from "./TaxRiskEvaluate.vue?vue&type=script&lang=js"
import style0 from "./TaxRiskEvaluate.vue?vue&type=style&index=0&id=6b3e6a5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e6a5c",
  null
  
)

export default component.exports